import { isPlatformBrowser } from "@angular/common";
import {
    Directive,
    DOCUMENT,
    inject,
    OnInit,
    PLATFORM_ID,
} from "@angular/core";
import { environment } from "../../../../../../environments/environment";
import { eventThemeDefault } from "../../../../../constants/event-theme.constants";

@Directive({
    selector: "[lsAddClassEventTheme]",
    standalone: true,
})

export class AddClassEventThemeDirective implements OnInit {
    public eventTheme: string = environment.eventTheme;
    public minioUrl: string = environment.minioUrl;

    private readonly platformId: object = inject(PLATFORM_ID);
    private readonly document: Document = inject(DOCUMENT);

    public ngOnInit(): void {
        if (!isPlatformBrowser(this.platformId)) {
            return;
        }

        if (this.eventTheme !== eventThemeDefault) {
            this.document.body.classList.add(this.eventTheme);

            const buttonBgSettings: string = "repeat-x bottom left / auto 100%";
            const buttonBgFileName: string = "btn-primary-bg.svg";

            this.document.documentElement.style.setProperty(
                "--ls-event-theme-btn-primary-bg",
                `url(${this.minioUrl}event-themes/${this.eventTheme}/images/${buttonBgFileName}) ${buttonBgSettings}`,
            );
        }
    }
}
